import React from 'react'
import styled from 'styled-components'

import Card from './card'

const Columns = styled.div.attrs({className:'card-columns'})`
 && {
    column-count: 2;
    column-gap: 40px;
    @media (max-width: 767.98px) { column-count: 1; }
 }

`
const getLogo = (name) => {
  let logo;
  if(name === 'Placer.ai'){
    logo = require(`../assets/companies/placer.png`)
    return logo
  }else if(name === 'Uniper Care'){
    logo = require(`../assets/companies/uniper.png`)
    return logo
  }
  try {
    logo = require(`../assets/companies/${encodeURIComponent(name.replace(/\s/g, '').toLowerCase())}@2x.png`)
  } catch(e) {
    try{
      logo = require(`../assets/companies/${encodeURIComponent(name.replace(/\s/g, '').toLowerCase())}.png`)
    } catch (e) {
      logo = require('../assets/companies/placeholder.png')
    }
  }
  return logo
}

const Cards = ({positions = [], user = null}) => <Columns>
  {positions
    .filter((position) => position.description && position.link)
    .map((position, index) => {
    return <Card key={index} length={230} logo={getLogo(position.company)} user={user} {...position}/>
  })}
</Columns>

export default Cards



// WEBPACK FOOTER //
// ./src/components/cards.js